import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Button, { ButtonVariants } from '../../atoms/Button';
import { FilterInput } from '../../atoms/filters/FilterInput';
import { FilterListbox, } from '../../atoms/filters/FilterListbox';
import Delete from '../../atoms/icons/Delete';
import InputWrapper from '../../atoms/InputWrapper';
import { HStack } from '../../atoms/Stack';
import { FilterActionKind, FilterReducer, } from './FilterTableHeader.state';
import debounce from 'lodash/debounce';
const StyledContainer = styled(HStack) `
    padding: 0.5rem 0;
`;
const StyledDelete = styled(Delete) `
    width: 20px;
    height: 20px;
    fill: white;
`;
const StyledInputWrapper = styled(InputWrapper) `
    flex-shrink: 0;
    margin-top: 22px;
`;
export const FilterTableHeader = ({ onSubmit, values = {}, options, }) => {
    const { t } = useTranslation();
    const [state, dispatch] = useReducer(FilterReducer, values);
    const isTouched = state.domain ||
        state.minimum_detections ||
        state.ignored ||
        state.status;
    useEffect(() => {
        debounce(() => onSubmit(state), 300)();
    }, [state.domain, state.minimum_detections, state.ignored, state.status]);
    const handleSourceChange = (value) => {
        dispatch({
            type: FilterActionKind.FILTER_IGNORED,
            payload: value,
        });
    };
    const handleStatusChange = (value) => {
        dispatch({ type: FilterActionKind.FiLTER_STATUS, payload: value });
    };
    const handleMinimumDetectionsChange = e => {
        dispatch({
            type: FilterActionKind.FILTER_MINIMUM_DETECTIONS,
            payload: e.target.value,
        });
    };
    const handleSearchChange = e => {
        dispatch({
            type: FilterActionKind.FILTER_DOMAIN,
            payload: e.target.value,
        });
    };
    const handleClearFields = (name) => () => {
        dispatch({
            type: FilterActionKind.CLEAR_FIELD_FILTERS,
            payload: name,
        });
    };
    const handleClearAll = () => {
        dispatch({ type: FilterActionKind.CLEAR_ALL_FILTERS });
    };
    return (_jsxs(StyledContainer, { "data-testid": "filter-table-header", spacing: "20px", children: [_jsx("div", { "data-testid": "filter-table-header__source", children: _jsx(FilterListbox, { label: t('copyright_checker.filters.source.label'), placeholder: t('copyright_checker.filters.source.placeholder'), value: state.ignored ?? '', onChange: handleSourceChange, options: options.sources }) }), _jsx("div", { "data-testid": "filter-table-header__status", children: _jsx(FilterListbox, { label: t('copyright_checker.filters.status.label'), placeholder: t('copyright_checker.filters.status.placeholder'), value: state.status ?? '', onChange: handleStatusChange, options: options.statuses }) }), _jsx("div", { "data-testid": "filter-table-header__minimum-detections", children: _jsx(FilterInput, { label: t('copyright_checker.filters.minimum_detections.label'), type: "number", name: "minimum_detections", value: state.minimum_detections ?? '', onChange: handleMinimumDetectionsChange, onClear: handleClearFields, placeholder: t('copyright_checker.filters.minimum_detections.placeholder') }) }), _jsx("div", { "data-testid": "filter-table-header__domain", children: _jsx(FilterInput, { label: t('copyright_checker.filters.search.label'), name: "domain", value: state.domain ?? '', onChange: handleSearchChange, onClear: handleClearFields, placeholder: t('copyright_checker.filters.search.placeholder') }) }), isTouched && (_jsx(StyledInputWrapper, { children: _jsx(Button, { "data-testid": "filter-table-header__clear-all", variant: ButtonVariants.Red, icon: _jsx(StyledDelete, {}), onClick: handleClearAll, children: t('copyright_checker.filters.clear_action') }) }))] }));
};
